import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/assets/img/pdf/EnergieExpertenLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-4b0d5271"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-4 text-base font-bold",
  "data-cy": "custom-input-title"
}
const _hoisted_2 = {
  key: 1,
  class: "flex-1 w-full my-2",
  "data-cy": "custom-input-table"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_4 = { class: "text-left numberCol data-tr" }
const _hoisted_5 = {
  key: 2,
  "data-cy": "keine-maengel-vorhanden"
}
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { style: {"bottom":"70px","position":"absolute"} }
const _hoisted_8 = {
  class: "mt-8",
  "data-cy": "ansprechpartner",
  style: {"position":"relative","width":"150%"}
}
const _hoisted_9 = { class: "flex mt-4" }
const _hoisted_10 = {
  class: "flex flex-col w-1/2",
  "data-cy": "signatur-1"
}
const _hoisted_11 = { style: {"height":"70px"} }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "border-top-dotted-1 ml-4" }
const _hoisted_14 = { class: "text-xxs mt-2" }
const _hoisted_15 = {
  class: "flex flex-col w-1/2",
  "data-cy": "signatur-2"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "EnergieExperten Logo",
  style: {"width":"150px","height":"150","position":"absolute","bottom":"30px","right":"0px"}
}, null, -1))
const _hoisted_17 = { style: {"height":"70px"} }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "border-top-dotted-1 ml-4" }
const _hoisted_20 = { class: "text-xxs mt-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_page_header = _resolveComponent("pdf-page-header")!
  const _component_pdf_row_custom_input = _resolveComponent("pdf-row-custom-input")!
  const _component_pdf_color_codes = _resolveComponent("pdf-color-codes")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedCustomInput, (customInputPage, index) => {
    return (_openBlock(), _createBlock(_component_pdf_a4_page, {
      key: index,
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createVNode(_component_pdf_page_header, {
          immobilie: _ctx.immobilie,
          hzba: _ctx.ba,
          "tech-data": _ctx.techData,
          "is-hinweis-uebersicht": true,
          lang: _ctx.lang,
          title: _ctx.title,
          "crumbs-beginning": _ctx.crumbsBeginning,
          "crumbs-middle": _ctx.crumbsMiddle,
          "crumbs-end": _ctx.crumbsEnd
        }, null, 8, ["immobilie", "hzba", "tech-data", "lang", "title", "crumbs-beginning", "crumbs-middle", "crumbs-end"]),
        (index === 0)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        (customInputPage && customInputPage.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.t("hzba.pdf.ensimimav.bezeichnung-beschreibung", 1, { locale: _ctx.lang })), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customInputPage, (customInputData, index) => {
                return (_openBlock(), _createBlock(_component_pdf_row_custom_input, {
                  key: index,
                  "custom-input-data": customInputData,
                  odd: index % 2 === 0
                }, null, 8, ["custom-input-data", "odd"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.noValues), 1)),
        (_ctx.unterschrift && index === _ctx.pagedCustomInput.length-1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        (_ctx.ba.unterschrifts.length > 0)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.getPhotoUrl(_ctx.ba.unterschrifts[0].bild),
                              class: "object-cover mt-1 signature",
                              style: {"height":"70px"}
                            }, null, 8, _hoisted_12))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString("Aufgenommen von " + _ctx.ba.gutachter.username + " am " + _ctx.moment(_ctx.ba.begehungsdatum).format("DD.MM.YYYY")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        (_ctx.ba.technProjektsteuerungUnterschrift !== undefined)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.getPhotoUrl(_ctx.ba.technProjektsteuerungUnterschrift),
                              class: "object-cover mt-1 signature",
                              style: {"height":"70px"}
                            }, null, 8, _hoisted_18))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createTextVNode(_toDisplayString("Geprüft von " + _ctx.ba.technProjektsteuerungName + " am " + _ctx.moment(_ctx.ba.freigabeDatum).format("DD.MM.YYYY")), 1),
                          _hoisted_21
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_pdf_color_codes, {
          class: "ml-1",
          lang: _ctx.lang
        }, null, 8, ["lang"])
      ]),
      _: 2
    }, 1032, ["pdf-key"]))
  }), 128))
}